export default __webpack_public_path__ + "static/media/top-selling-skus.d57573d7.svg";